<app-modal-container>
  <div class="modal-header-content">
    {{ 'remove_sso' | translate }}
  </div>
  <div class="modal-body-content">
    <div class="row flex-column mb-4 text-black">
      <div class="col-12 mb-3 fw-bold">
        {{ 'remove_sso_are_you_sure' | translate: tenantName }}
      </div>
      <div class="col-12">
        {{ 'remove_sso_explanation' | translate }}
      </div>
    </div>

    <form [formGroup]="form">
      <div class="row mb-4">
        <div class="col-12">
          <input type="checkbox" [formControlName]="FORM_FIELDS.confirmed" id="confirmation" />
          <label for="confirmation" class="ms-2">
            {{ 'remove_sso_checkbox_acknowledgement' | translate }}
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex flex-column">
          <label for="removalReason" class="fw-bold">
            {{ 'reason_for_removing_sso_required' | translate }}
          </label>
          <span class="text-black">{{ 'reason_and_account_captured_audit_log' | translate }}</span>
          <div>
            <textarea class="form-element w-100" id="removalReason" rows="5" [formControlName]="FORM_FIELDS.reason"></textarea>
            <app-form-field-error
              name="reason"
              [formValidationRequest$]="formValidationRequest$"
              [field]="form.get(FORM_FIELDS.reason)"
              [label]="'reason_for_removing_sso' | translate"
            ></app-form-field-error>
          </div>
          <app-form-field-char-count [field]="form.get(FORM_FIELDS.reason)" [charLimit]="reasonCharLimit">
          </app-form-field-char-count>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer-content">
    <div class="row justify-content-between">
      <div class="col-auto">
        <button class="btn btn-outline-primary" (click)="container.closeModal()">
          {{ 'form_cancel' | translate }}
        </button>
      </div>
      <div class="col-auto">
        <button class="btn btn-lg btn-primary" [disabled]="!form.valid" (click)="removeSso()">
          {{ 'remove_sso' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal-container>
